import { autoserialize, autoserializeAs } from 'cerialize';
import { Color } from '../enums/color';

export class DetectionDensity {
  @autoserialize index!: number;
  @autoserialize count!: number;
  @autoserialize point!: Array<number>;
  @autoserializeAs('camera_direction') cameraDirection!: Array<number>;
  @autoserializeAs('rotation_matrix') rotationMatrix!: Array<Array<number>>;
  @autoserialize length!: number;
  @autoserialize dimensions!: Array<number>;
  colorHex!: string;

  constructor() {
    this.colorHex = Color.ANALOGOUS_1;
  }
}

export class VolumeDensity  {
  @autoserialize index!: number;
  @autoserialize count!: number;
  @autoserialize point!: Array<number>;
  @autoserializeAs('camera_direction') cameraDirection!: Array<number>;
  @autoserializeAs('rotation_matrix') rotationMatrix!: Array<Array<number>>;
  @autoserialize length!: number;
  @autoserialize dimensions!: Array<number>;
  colorHex!: string;

  constructor() {
    this.colorHex = Color.ANALOGOUS_2;
  }
}

export class DetectionSummary {
  @autoserializeAs('detection_count')
  detectionCount!: number;

  @autoserializeAs('emergency_count')
  emergencyCount!: number;

  @autoserializeAs('density_peak')
  densityPeak!: number;

  @autoserializeAs(DetectionDensity)
  densities: DetectionDensity[] = [];

  @autoserialize
  evolution!: number;
}

export class VolumeSummary {
  @autoserializeAs('positive_volume_moved')
  positiveVolumeMoved!: number;

  @autoserializeAs('negative_volume_moved')
  negativeVolumeMoved!: number;

  @autoserializeAs('emergency_count')
  emergencyCount!: number;

  @autoserializeAs('density_peak')
  densityPeak!: number;
}

export class Site {
  @autoserialize id!: string;
  @autoserialize name!: string;
  @autoserialize slug!: string;
  @autoserialize organization!: string;
  @autoserialize sector!: string;
  @autoserializeAs('emergency_level')  emergencyLevel!: number;
  @autoserializeAs('emergency_label')  emergencyLabel!: number;
  @autoserializeAs('hex_color')  color!: string;
  @autoserialize modules!: Array<number>;
  @autoserialize pin!: any;
  @autoserialize altitude!: number;
  @autoserialize height!: number;
  @autoserialize outline!: [];
  @autoserialize status!: number;
  @autoserializeAs('structure_ttl_hours') structureTtlHours!: number;
  @autoserializeAs('structure_stop_eta') structureStopEta!: string;
  @autoserializeAs('last_batch') lastBatch!: string;
  @autoserializeAs('last_batch_date') lastBatchDate!: string;
  @autoserializeAs(DetectionSummary, 'detection_summary') detectionSummary?: DetectionSummary;
  @autoserializeAs('have_detection_emergency_template')  haveDetectionEmergencyTemplate!: boolean;
  @autoserializeAs(VolumeSummary, 'volume_summary') volumeSummary?: VolumeSummary;
  border!: string;
  backgroundColor!: string;
  textColor!: string;
}
